import { createContext as o } from "react";
const t = o(document.body);
t.displayName = "PortalRootContext";
export {
  t as PortalRootContext
};
